import React, { useContext } from "react";

import { ElementState, Preview } from "@creatomate/preview";
import { Icon } from "@culturehq/components";

import { Trans } from "app/utils";

import { CreatomateContext } from "components/stories/video-studio/contexts/VideoStudioContext";
import { deleteSections, isSubtitleText } from "components/stories/video-studio/sidebar/tabs/subtitle/utils";
import ContextMenuOption from "./ContextMenuOption";

interface DeleteOptionProps {
  currentElement: ElementState;
  onSetContextMenuVisible: (value: boolean) => void;
  preview: Preview;
}

const DeleteOption: React.FC<DeleteOptionProps> = ({
  currentElement,
  onSetContextMenuVisible,
  preview
}) => {
  const { data, handleAutosaveDraft } = useContext(CreatomateContext);
  const { activeElementsId, subtitles } = data;

  const deleteElement = async () => {
    const source = preview.getSource();
    const { elements } = source;

    if (elements) {
      const elementsToKeep = elements.filter((element: any) => (
        !activeElementsId.includes(element.id)
      ));

      await preview.setSource({
        ...source,
        elements: elementsToKeep
      }, true);
    }
  };

  const handleDeleteElement = async () => {
    if (!activeElementsId.includes(currentElement.source.id)) {
      preview.setActiveElements([currentElement.source.id]);
    }
    if (isSubtitleText(currentElement.source.name)) {
      await deleteSections(subtitles, currentElement, preview, handleAutosaveDraft);
    }
    await deleteElement();
    onSetContextMenuVisible(false);
  };

  return (
    <ContextMenuOption onClick={handleDeleteElement}>
      <Icon className="Delete-Element" icon="trash-a-outlined" />
      <Trans>Delete</Trans>
    </ContextMenuOption>
  );
};

export default DeleteOption;
